import { TFunction } from 'i18next';

import { CONSIGNMENT_STATUS, ConsignmentStatusCode } from '@/entities/consignments';
import type { SelectOption } from '@/shared/ui';

export const getMetricOptions = (t: TFunction): SelectOption[] => [
  { value: 'W', label: t('hover.weight', 'Weight') },
  { value: 'V', label: t('hover.volume', 'Volume') },
  { value: 'VA', label: t('filter.metric.value', 'Value') },
  { value: 'C', label: t('cmrlist.title', 'Consignments') },
  { value: 'L', label: t('filter.metric.lines', 'Lines') },
  { value: 'D', label: t('requestline.isDangerous.label', 'Dangerous') }
];

export const getGroupByOptions = (t: TFunction): SelectOption[] => [
  { value: 'D', label: t('filter.group.date', 'Date') },
  { value: 'W', label: t('filter.group.week', 'Week') },
  { value: 'L', label: t('report.customerlocations.label', 'Location') },
  { value: 'S', label: t('subregion.name.label', 'Subregion') },
  { value: 'R', label: t('region.name.label', 'Region') },
  { value: 'U', label: t('org.sender.label', 'Organization') },
  { value: 'T', label: t('filter.group.type', 'Type') },
  { value: 'P', label: t('map.popup.product', 'Product') }
];

export const getDateRangeOptions = (t: TFunction): SelectOption[] => [
  { value: 'LW', label: t('filter.period.lastWeek', 'Last Week') },
  { value: 'L2W', label: t('filter.period.last2Weeks', 'Last 2 Weeks') },
  { value: 'LM', label: t('filter.period.lastMonth', 'Last Month') },
  { value: 'L2M', label: t('filter.period.last2Months', 'Last 2 Months') },
  { value: 'L6M', label: t('filter.period.last6Months', 'Last 6 Months') },
  { value: 'LY', label: t('filter.period.lastYear', 'Last Year') },
  { value: 'FE', label: t('filter.period.allTime', 'All Time') },
  { value: 'CR', label: t('filter.period.customRange', 'Custom Range') }
];

export const getStatusOptions = (t: TFunction): SelectOption[] => [
  { value: 'DI', label: t('cmrlist.dispatched', 'Dispatched') },
  { value: 'RC', label: t('report.totreceived.label', 'Received') }
];

export const getTransportGroupOptions = (t: TFunction): SelectOption[] => [
  { value: 'D', label: t('filter.group.date', 'Date') },
  { value: 'OL', label: t('filter.group.originLocation', 'Origin Location') },
  { value: 'OS', label: t('filter.group.originSubregion', 'Origin Subregion') },
  { value: 'OR', label: t('filter.group.originRegion', 'Origin Region') },
  { value: 'DL', label: t('dest.label', 'Destination') },
  { value: 'DS', label: t('filter.group.destSubregion', 'Destination Subregion') },
  { value: 'DR', label: t('filter.group.destRegion', 'Destination Region') },
  { value: 'SO', label: t('filter.group.senderOrg', 'Sender Org') },
  { value: 'SOT', label: t('filter.group.senderType', 'Sender Type') },
  { value: 'P', label: t('map.popup.product', 'Product') }
];

export const getBreakdownOptions = (t: TFunction): SelectOption[] => [
  { value: 'NO', label: t('filter.breakdown.none', 'None') },
  { value: 'OL', label: t('filter.breakdown.originLocation', 'Origin Location') },
  { value: 'DL', label: t('filter.breakdown.destinationLocation', 'Destination Location') },
  { value: 'CO', label: t('filter.breakdown.condition', 'Condition') },
  { value: 'CD', label: t('filter.breakdown.commodity', 'Commodity') }
];

export const getConsignmentsStatusOptions = (t: TFunction): SelectOption<ConsignmentStatusCode | ''>[] => [
  { value: '', label: t('common.all', 'All') },
  { value: CONSIGNMENT_STATUS.AC, label: t('cmrlist.filters.accepted.label', 'Accepted') },
  { value: CONSIGNMENT_STATUS.CA, label: t('cmrlist.filters.cancelled.label', 'Cancelled') },
  { value: CONSIGNMENT_STATUS.CL, label: t('cmrlist.filters.closed.label', 'Closed') },
  { value: CONSIGNMENT_STATUS.IP, label: t('cmrlist.filters.inProgress.label', 'In Progress') },
  { value: CONSIGNMENT_STATUS.NR, label: t('cmrlist.filters.new.label', 'New') },
  { value: CONSIGNMENT_STATUS.OH, label: t('cmrlist.filters.onHold.label', 'On Hold') }
];

export const getTransportModeOptions = (
  t: TFunction,
  vehicleCategories: { id: number; description: string }[]
): SelectOption[] => [
  { value: 'NO', label: t('gen.none.label', 'None') },
  ...vehicleCategories.map((vc) => ({ value: String(vc.id), label: t(`vehicleCategory.${vc.id}`, vc.description) }))
];
